import { render, staticRenderFns } from "./BackMoney.vue?vue&type=template&id=224e9489&scoped=true"
import script from "./BackMoney.vue?vue&type=script&lang=js"
export * from "./BackMoney.vue?vue&type=script&lang=js"
import style0 from "./BackMoney.vue?vue&type=style&index=0&id=224e9489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e9489",
  null
  
)

export default component.exports